import { render, staticRenderFns } from "./CheckoutConfig.vue?vue&type=template&id=31e20550&scoped=true&"
import script from "./CheckoutConfig.vue?vue&type=script&lang=js&"
export * from "./CheckoutConfig.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutConfig.vue?vue&type=style&index=0&id=31e20550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e20550",
  null
  
)

export default component.exports